import { Numeric8BoxMultipleOutlineIcon } from './Numeric8BoxMultipleOutlineIcon';

/**
 * author: Google
 * id 869A508B-5F8E-41A7-BCE5-E205FC66C80F
 * name numeric-8-box-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-8-box-multiple-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number8BoxMultipleOutlineIcon = Numeric8BoxMultipleOutlineIcon;
export default Number8BoxMultipleOutlineIcon